import { TicketRepository } from '../repositories/TicketRepository'

export function ListPersonaTicketAreaCase(ticketRepository: TicketRepository) {
  return async function () {
    return await ticketRepository.listPersonaTicketArea()
  }
}
